/* Dead Sea Mud — Limited-Time Offer section (v9). Vanilla JS, no dependencies. */
(function () {
  function init(root) {
    if (root.__dsmo) return; root.__dsmo = true;
    var cfgEl = root.querySelector('[data-dsmo-config]'); if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var annEl = $('.dsmo-ann');

    function scrollToEl(el, off) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - ((annEl ? annEl.offsetHeight : 0) + (off || 14));
      window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
    }
    function toPlans(e) {
      if (e) e.preventDefault();
      var el = $('#dsmo-plans-' + cfg.id); if (!el) return;
      scrollToEl(el, 24);
      var c = el.querySelector('input:checked'); if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, reduced ? 0 : 500);
    }
    $$('[data-to-plans]').forEach(function (b) { b.addEventListener('click', toPlans); });

    /* Hero rating link → "Real Skin. Real Resets." results section */
    $$('[data-open-tab]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector('.dsmr') || document.getElementById(a.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault(); scrollToEl(target, 0);
      });
    });

    /* Announcement rotation */
    var ann = $$('.dsmo-ann > span');
    if (ann.length > 1 && !reduced) { var ai = 0; setInterval(function () { ann[ai].classList.remove('is-on'); ai = (ai + 1) % ann.length; ann[ai].classList.add('is-on'); }, (cfg.annSpeed || 4) * 1000); }

    /* Gallery + thumbnails */
    var track = $('.dsmo-track'), thumbs = $$('.dsmo-tn button'), go = null;
    if (track) {
      var n = track.children.length, idx = 0;
      var mark = function (i) {
        thumbs.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        var t = thumbs[i], strip = t && t.parentElement;
        if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2, behavior: reduced ? 'auto' : 'smooth' });
      };
      go = function (i) { i = (i % n + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); };
      var sync = function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idx) { idx = i; mark(i); } };
      var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      thumbs.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var p = $('.dsmo-arrow--prev'), nx = $('.dsmo-arrow--next');
      if (p) p.addEventListener('click', function () { go(idx - 1); });
      if (nx) nx.addEventListener('click', function () { go(idx + 1); });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); } if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); } });
    }

    /* Countdown — fixed end date from settings */
    var end = Date.parse(cfg.end), expired = !(end > Date.now()), t = null;
    var pad = function (x) { return (x < 10 ? '0' : '') + x; };
    function expire() {
      expired = true; root.classList.add('is-expired');
      if (cfg.expiry === 'hide_gifts') root.classList.add('no-gifts');
      if (cfg.expiry === 'message') $$('[data-ended]').forEach(function (e) { e.hidden = false; });
      updateCta();
    }
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s <= 0) { clearInterval(t); expire(); return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      var txt = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      $$('[data-timer-text]').forEach(function (e) { e.textContent = txt; });
    }

    /* Plan → CTA URL, prices, gift-lock view (data-plan) and selected-plan imagery (data-sel) */
    var plans = $$('input[name="dsmo-plan-' + cfg.id + '"]');
    function updateCta() {
      var sel = plans.filter(function (p) { return p.checked; })[0]; if (!sel) return;
      var o = cfg.sub[sel.value];
      root.setAttribute('data-plan', cfg.lock === false ? '2' : sel.value);
      root.setAttribute('data-sel', sel.value);
      var url = (expired && cfg.expiry === 'redirect' && cfg.expiredUrl) ? cfg.expiredUrl : o.url;
      $$('[data-cta]').forEach(function (a) { a.href = url || '#'; });
      $$('[data-price]').forEach(function (e) { e.textContent = o.price; });
      $$('[data-compare]').forEach(function (e) { e.textContent = o.cmp; });
      $$('[data-jarline]').forEach(function (e) { e.textContent = o.jars + ' ' + (cfg.ofMud || 'of Dead Sea Mud'); });
      try { localStorage.setItem('dsmo-plan-' + cfg.id, sel.value); } catch (e) {}
    }
    try { var saved = localStorage.getItem('dsmo-plan-' + cfg.id); plans.forEach(function (p) { if (p.value === saved) p.checked = true; }); } catch (e) {}
    plans.forEach(function (p) { p.addEventListener('change', function () { updateCta(); if (go) go(0); }); });
    $$('[data-unlock]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var p2 = plans.filter(function (p) { return p.value === '2'; })[0];
        if (p2) { p2.checked = true; updateCta(); if (go) go(0); toPlans(); }
      });
    });
    updateCta();
    if (expired) expire(); else { tick(); t = setInterval(tick, 1000); }

    /* One-time purchase */
    var otpBtn = $('[data-otp-toggle]'), otp = $('.dsmo-otp');
    if (otpBtn && otp) otpBtn.addEventListener('click', function () { var open = otp.hidden; otp.hidden = !open; otpBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    var otps = $$('input[name="dsmo-otp-' + cfg.id + '"]'), otpCta = $('[data-otp-cta]');
    function updateOtp() { var s = otps.filter(function (o) { return o.checked; })[0]; if (!s || !otpCta) return; var o = cfg.otp[s.value]; otpCta.href = o.url || '#'; otpCta.textContent = (cfg.otpCta || 'Buy once — [price]').replace('[jars]', o.jars).replace('[price]', o.price); }
    otps.forEach(function (o) { o.addEventListener('change', updateOtp); }); updateOtp();

    /* UGC videos: tap to play / pause */
    $$('.dsmo-vid').forEach(function (v) {
      var vid = v.querySelector('video'); if (!vid) return;
      vid.muted = true; vid.setAttribute('playsinline', ''); vid.loop = true;
      if (vid.autoplay && !reduced) v.classList.add('is-playing'); else { vid.autoplay = false; vid.pause(); }
      v.addEventListener('click', function () {
        if (vid.paused) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); v.classList.add('is-playing'); }
        else { vid.pause(); v.classList.remove('is-playing'); }
      });
    });

    /* Sticky CTA: shows after the main CTA scrolls away */
    var sticky = $('.dsmo-sticky'), mainCta = $('[data-main-cta]');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          var on = !(e.isIntersecting || e.boundingClientRect.top > 0);
          sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          var a = sticky.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
        });
      });
      io.observe(mainCta);
    }
  }
  function boot() { document.querySelectorAll('[data-dsmo]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-dsmo]'); if (r) init(r); });
  document.addEventListener('shopify:block:select', function (e) { var sl = e.target.closest && e.target.closest('.dsmo-slide'); if (sl && sl.parentElement) sl.parentElement.scrollTo({ left: sl.offsetLeft, behavior: 'auto' }); });
})();